// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CarTwoToneSvg from "@fishx/icons-svg/es/asn/CarTwoTone";
import FishxIcon from '../components/FishxIcon';

var CarTwoTone = function CarTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: CarTwoToneSvg
  }));
};

CarTwoTone.displayName = 'CarTwoTone';
export default React.forwardRef(CarTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/CarTwoTone.js
// module id = 2166
// module chunks = 0